import { type HttpClient } from '@/application/interfaces/http-client';

import { getCrossesServices } from './get-crosses-services';
import { getCrossServices } from './get-services';

const CrossesService = (httpClient: HttpClient.Instance) => ({
  getCrossesServices: getCrossesServices(httpClient),
  getCrossServices: getCrossServices(httpClient),
});

export default CrossesService;
